import jwtAxios from "axios";
import { getEnvironment } from "./environmentService";

const jwtAuthAxios = jwtAxios.create({
    baseURL: "/be/api/",
    headers: {
        'Content-Type': 'application/json'
    }
});

// Kirim environment aktif (production/development) ke backend tiap request.
// Backend merutekan koneksi DB sesuai header ini (per-client, default production).
jwtAuthAxios.interceptors.request.use((config) => {
    config.headers = config.headers || {};
    if (!config.headers['X-App-Env']) {
        config.headers['X-App-Env'] = getEnvironment();
    }
    return config;
});

jwtAuthAxios.interceptors.response.use(
    res => res,
    err => {
        if(err.response && err.response.data.type === "token-invalid") {
            //todo logout the user
        }
        return Promise.reject(err);
    }
);

export const setTokenManual = (token) => {
    //console.log('set token : ',token)
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
};

export const setToken = (token,roles) => {
    //console.log("roles : "+roles);
    //console.log(token)
    //console.log(roles)
    if(token) {
        jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
        sessionStorage.getItem('token');
        sessionStorage.setItem('roles', roles);
        sessionStorage.setItem('isAuthenticated',true);
    } else {
        delete jwtAuthAxios.defaults.headers.common['Authorization'];
        sessionStorage.removeItem('token');
        sessionStorage.removeItem('roles');
        sessionStorage.removeItem('isAuthenticated');
    }
};

export const setAuthToken = (token,roles) => {
    //console.log("roles : "+roles);
    //console.log(token)
    //console.log(roles)
    if(token) {
        jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
        sessionStorage.setItem('token', token);
        sessionStorage.setItem('roles', roles);
        sessionStorage.setItem('isAuthenticated',true);
    } else {
        delete jwtAuthAxios.defaults.headers.common['Authorization'];
        sessionStorage.removeItem('token');
        sessionStorage.removeItem('roles');
        sessionStorage.removeItem('isAuthenticated');
    }
};

export const getAuthToken = () => {
    return sessionStorage.getItem("token");
};

//todo: define interceptors and other configuration like baseURL, headers etc. here
export default jwtAuthAxios;